import React from 'react';
import _ from 'lodash';
import { number, func, shape, string, array, bool, oneOfType } from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
const getName = (name) => _.replace(name, /\./g, ' ');

const SelectField = ({ field, value, errors, onChange, options, disableAction, ...others }) => {
  const key = field.key || field.name || 'key';
  const inputKey = `form-${key}`;
  const name = field.name || 'field';
  const helpertext = field.helpertext || '';
  const disabled = disableAction || field.disabled || false;
  const type = field.type || 'text';

  let errorText = _.get(errors, key, false);

  let getValue = (value, options) => {
    if (value !== '') {
      return value;
    }

    //value is blank., return the default
    let i = 0;
    for (i = 0; i < options.length; i++) {
      if (options.default === true) {
        return options.value;
      }
    }

    //if no defaults, return empty string
    return '';
  }

  return (

    <FormControl variant="standard">
      <InputLabel htmlFor={name} disabled={disabled}>{getName(name)}</InputLabel>
      <Select
        key={inputKey}
        name={name}
        value={getValue(value, options) }
        disabled={disabled}
        onChange={onChange}
        inputProps={{
          name: name,
          id: inputKey,
        }}
      >                          
        {options.map(option => {
            return(<MenuItem   key={inputKey + option.value} value={option.value}>{option.text}</MenuItem>);
        })}         
      </Select>
    </FormControl>

  );
};

SelectField.defaultProps = {
  errors: {},
  multiline: false,
};

SelectField.propTypes = {
  onChange: func.isRequired,
  field: shape({
    name: string,
    key: string,
    disabled: bool,
  }).isRequired,
  value: oneOfType([string, number, array]),
  errors: shape({})
};

export default SelectField;
